import {ApiPathParam} from '../../../../../models/SearchParamSchema';
import {formAPIPageable} from '../../../../../utils/StringUtils';

export const GET_REGISTERED_EXAM = '/';
export const GET_EXAM_SERIES = '/';
export const GET_PENDING_REGISTRATION = '/pending-registration';
export const GET_EXAM_TYPES = '/exam-types';
export const GET_ADMISSION_EXAM_LEVEL = (examType: string) => `/admission-exam-level/${examType}`;
export const GET_CEQ_TYPES = '/ceq-types';
export const GET_CEQ_REQUIRED = '/admission-level/ceq-required';
export const POST_CREATE_EXAM_REGISTRATIONS = '/';
export const POST_CREATE_NON_EXAM_REGISTRATIONS_TOKEN = (token: string) => `?token=${token}`;
export const POST_CREATE_NONE_EXAM_REGISTRATIONS = '/';
export const POST_CREATE_EXAM_REGISTRATIONS_TOKEN = (token: string) => `?token=${token}`;
export const POST_CREATE_EXAM_AMENDMENT = '/';
export const GET_EXAM_WITHDRAWAL = '/';
export const POST_EXAM_WITHDRAWAL_UPLOAD_DOCUMENT = '/';
export const PUT_DRAFT_DELETE = '/draft-delete';
export const PUT_UNDO_DRAFT_DELETE = '/undo-draft-delete';
export const POST_CANDIDATE_EXAM_PAYMENT = '/confirm-and-pay';
export const POST_SAVE_DRAFT_ADDED_SUBJECT_AMENDMENT = '/exam-registration-details';
export const GET_EXAM_TRANSACTION_INFO = (uuid: string) => `/${uuid}/registration-receipt`;
export const GET_CANDIDATE_EXAM_PROFILE = (uuid: string) => `/${uuid}/candidate-profile`;
export const GET_CANDIDATE_EXAM_REGISTRATION = (uuid: string) => `/${uuid}/registration-summary`;
export const GET_SELECTED_SUBJECTS = (uuid: string) => `/${uuid}/selected-subjects`;
export const POST_CANDIDATE_EXAM_REGISTRATION_PROFILE = (uuid: string) =>
    `/${uuid}/candidate-profile-and-exam-registration`;
export const GET_CANDIDATE_EXAM_DOWNLOAD_SUMMARY = (uuid: string) =>
    `/${uuid}/download-registration`;
export const GET_CANDIDATE_EXAM_REGISTRATION_SUMMARY = (uuid: string) => `/${uuid}`;
export const DELETE_CANDIDATE_EXAM_REGISTRATION_DRAFT = (uuid: string) => `/${uuid}`;
export const POST_CREATE_EXAM_WITHDRAWAL = (uuid: string, token?: string) =>
      `/${uuid}/withdrawal${token ? `?token=${token}` : ''}`;
export const GET_EXAM_SUBJECTS = (params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `/search${tparams}`;
};

export const POST_EXAM_SUBJECT_REGISTRATION_DRAFT = (applicationUuid: string) =>
    `/${applicationUuid}/selected-subjects`;
export const PUT_EXAM_SUBJECT_REGISTRATION_DRAFT = (applicationUuid: string, subjectUuid: string) =>
    `/${applicationUuid}/selected-subjects/${subjectUuid}`;
export const PUT_EXAM_SUBJECT_AMENDMENT_REGISTRATION_DRAFT = (
    applicationUuid: string,
    subjectUuid: string
) => `/${applicationUuid}/selected-subjects/${subjectUuid}`;
export const DELETE_EXAM_EXAM_SUBJECT_REGISTRATION_DRAFT = (
    applicationUuid: string,
    subjectUuid: string
) => `/${applicationUuid}/selected-subjects/${subjectUuid}`;

export const GET_SUBJECT_DETAIL = (applicationUuid: string, subjectCode: string) =>
    `${applicationUuid}/subjects/${subjectCode}/details`;
export const POST_EXAM_LEVEL = '/exam-levels/search';
export const GET_LANGUAGES = '/languages';
export const GET_EXAM_LEVEL_AMENDMENT = '/exam-level';
export const GET_CANDIDATE_REGISTERED_SUBJECT = (
    applicationUuid: string,
    examRegistrationDetailsUuid: string
) => `/${applicationUuid}/selected-subjects/${examRegistrationDetailsUuid}`;
export const GET_REGISTERED_SUBJECT = (subjectCode: string) =>
    `/${subjectCode}/registered-subjects`;
export const GET_CANDIDATE_REGISTERED_EXAM_AMENDMENT = (
    applicationUuid: string,
    subjectCode: string
) => `/${applicationUuid}/registered-subjects/${subjectCode}`;
export const GET_CANDIDATE_EXAM_AMENDMENT_SUMMARY = (uuid: string) => `/${uuid}/view-receipt`;
export const GET_CANDIDATE_REVIEW_EXAM_AMENDMENT = (uuid: string) => `/${uuid}/preview-payment`;
export const GET_CANDIDATE_REVIEW_EXAM_AMENDMENT_WITH_TOKEN = (uuid: string, token: string) =>
    `/${uuid}/preview-payment?token=${token}`;
export const GET_CANDIDATE_EXAM_AMENDMENT_DOWNLOAD_SUMMARY = (uuid: string) =>
    `/${uuid}/download-amendment`;
export const POST_SUBJECT_VALIDATION = (uuid: string) => `/${uuid}/get-subject-validation`;
export const GET_TRANSACTION_HISTORY = (params: ApiPathParam) => {
  const pathParams = formAPIPageable(params);
  return `/transaction-history${pathParams}`;
};
export const GET_WITHDRAWAL = (uuid: string) => `/${uuid}/registration-summary-and-open-window`;
export const PUT_WITHDRAWAL_DETAILS = (uuid: string) => `/${uuid}/withdrawal-details`;
export const GET_WITHDRAWAL_DRAFT = (uuid: string) => `/${uuid}/pending-withdrawal`;
export const GET_WITHDRAW_DETAILS = (uuid: string) => `/${uuid}/withdrawal`;
export const PUT_CONFIRM_WITHDRAW = (uuid: string) => `/${uuid}/withdrawal`;
export const GET_WITHDRAWAL_ACKNOWLEDGEMENT = (uuid: string) =>
    `/${uuid}/withdrawal-acknowledgement`;
export const GET_WITHDRAWAL_DOWNLOAD_PDF = (uuid: string) => `${uuid}/download-withdrawal`;
export const GET_SUBMITTED_WITHDRAWAL = (uuid: string) => `/${uuid}/submitted-withdrawal`;
export const GET_EXAM_LEVEL_WITHDRAWAL = () => `/withdrawal/exam-level`;
export const GET_WITHDRAWAL_TIMESTAMP = '/draft-datetime';
export const GET_PARENT_PARTICULAR_PROFILE = (uuid: string) => `/${uuid}/parent-particulars`;
